import * as Yup from 'yup';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
import { repeatTypeOptions } from '../../../helpers/options';
//////////////////////////////////////////////////

const inputWrapperStyles = {
  mb: 25,
  width: 200,
};

export const getIsTriggerConditionTypeNumberField = (trigger) => {
  const triggers = [
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_LATE_DELIVERY,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_EVENT_LATE_DATE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TASK_MANAGEMENT,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_UNPLANNED_EVENT,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_EVENT_DETENTION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_SHIFT_REMAINING,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_EVENT_EARLY_DATE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRUCK_SERVICE_DATE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_TERMINATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_SERVICE_DATE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_APPOINTMENT_REQUIRED,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_EVENT_NO_STATUS_UPDATE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_SHIFT_REMAINING,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_LICENSE_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRUCK_DOCUMENT_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRUCK_INSURANCE_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_BRANCH_DOCUMENT_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_DOCUMENTS_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_CARRIER_CONTRACT_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_CARRIER_DOCUMENT_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_DOCUMENT_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_BRANCH_CREDIT_LIMIT_PERCENT,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_INSURANCE_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_CARRIER_INSURANCE_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_CERTIFICATE_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRUCK_REGISTRATION_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_CARRIER_CERTIFICATE_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_IN_GEOFENCING_LOCATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_REGISTRATION_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_EDI_TRANSACTION_ORDER_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_APPOINTMENT_REQUIRED_AFTER_CREATE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_CITIZENSHIP_VISA_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRUCK_COMPONENT_WARRANTY_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_COMPONENT_WARRANTY_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_CITIZENSHIP_PASSPORT_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_COMPENSATION_DETAILS_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_CITIZENSHIP_WORK_AUTH_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_CITIZENSHIP_GREEN_CARD_EXPIRATION,
    // safety shutoff expiration
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRUCK_DOCUMENT_SAFETY_SHUTOFF_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_DOCUMENT_SAFETY_SHUTOFF_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_DOCUMENTS_SAFETY_SHUTOFF_EXPIRATION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_CERTIFICATE_SAFETY_SHUTOFF_EXPIRATION,
  ];

  return R.includes(trigger, triggers);
};

const hasRepeatFields = (trigger) => {
  const triggers = [
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_LATE_PREDICTION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_SHIFT_REMAINING,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_ETA_LATE_PREDICTION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRUCK_SERVICE_OVERDUE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_DRIVER_SHIFT_REMAINING,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_SERVICE_OVERDUE,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_GPS_DEVICE_BATTERY_STATUS,
  ];

  return R.includes(trigger, triggers);
};

const repeatValueIsRequired = (repeatType) => {
  const repeatTypes = [
    GC.REPEAT_TYPE_DAILY,
    GC.REPEAT_TYPE_HOURLY,
    GC.REPEAT_TYPE_MONTHLY,
  ];

  return R.includes(repeatType, repeatTypes);
};

const repeatTypeIsRequired = (trigger, repeatValue) => {
  if (G.isNotNilAndNotEmpty(repeatValue)) return true;

  const triggers = [
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_LATE_PREDICTION,
    GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_ETA_LATE_PREDICTION,
  ];

  return R.includes(trigger, triggers);
};

const hasDispatchGroupInternalType = (trigger, notificationOptions) => R.compose(
  R.any(R.equals(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_INTERNAL_TYPE_DISPATCH_GROUP)),
  R.propOr([], GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_INTERNAL_TYPES),
  R.find(R.propEq(trigger, GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER)),
)(R.or(notificationOptions, []));

export const getFirstNotificationFieldset = ({ trigger, messageTypes }, { objectType }, notificationOptions) => [
  {
    type: 'text',
    isRequired: true,
    inputWrapperStyles,
    label: ['titles:name', 'Name'],
    fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_NAME,
  },
  {
    isRequired: true,
    inputWrapperStyles,
    type: 'reactSelect',
    shouldCustomChange: true,
    label: ['titles:trigger', 'Trigger'],
    closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
    options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER,
    fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER,
  },
  {
    isRequired: true,
    inputWrapperStyles,
    type: 'reactSelect',
    shouldCustomChange: true,
    disabled: G.isNilOrEmpty(objectType),
    label: ['titles:object-type', 'Object Type'],
    closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
    options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_OBJ_TYPE,
    fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_OBJ_TYPE,
  },
  {
    isMulti: true,
    inputWrapperStyles,
    type: 'reactSelect',
    useMenuPortalTarget: true,
    label: ['titles:roles', 'Roles'],
    closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
    options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_ROLE,
    fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_ROLE,
    isRequired: R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_INTERNAL, messageTypes),
  },
  {
    isMulti: true,
    type: 'reactSelect',
    useMenuPortalTarget: true,
    options: GC.FIELD_DISPATCHING_GROUP_GUIDS,
    fieldName: GC.FIELD_DISPATCHING_GROUP_GUIDS,
    label: ['titles:dispatching-group', 'Dispatching Group'],
    closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
    isRequired: R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_INTERNAL, messageTypes),
    inputWrapperStyles: {
      ...inputWrapperStyles,
      display: G.ifElse(
        hasDispatchGroupInternalType(trigger, notificationOptions),
        'flex',
        'none',
      ),
    },
  },
  {
    isRequired: true,
    inputWrapperStyles,
    type: 'reactSelect',
    disabled: G.isNilOrEmpty(trigger),
    label: ['titles:notification-level', 'Notification Level'],
    closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
    options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_LEVEL,
    fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_LEVEL,
  },
  {
    type: 'toggle',
    inputWrapperStyles,
    label: ['titles:notification-sound', 'Notification Sound'],
    fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_ALARM_ENABLED,
  },
];

export const getSecondNotificationFieldset = (props, optionsForSelect) => {
  const { values, triggers, condition } = props;

  const { conditionType, mailTemplateGuid } = optionsForSelect;

  const { trigger, operation, emailTypes, repeatType, repeatValue, messageTypes } = values;

  const isConditionTypeNotNilAndNotEmpty = G.isNotNilAndNotEmpty(conditionType);
  const disabled = R.and(G.isNotNilAndNotEmpty(triggers), G.isNilOrEmpty(condition));
  const isTriggerConditionTypeNumberField = getIsTriggerConditionTypeNumberField(trigger);

  let secondNotificationFieldset = [
    {
      disabled,
      inputWrapperStyles,
      type: 'reactSelect',
      shouldCustomChange: true,
      isRequired: isConditionTypeNotNilAndNotEmpty,
      label: ['titles:condition-type', 'Condition Type'],
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_TYPE,
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_TYPE,
    },
    {
      disabled,
      inputWrapperStyles,
      type: 'reactSelect',
      shouldCustomChange: true,
      label: ['titles:operation', 'Operation'],
      isRequired: isConditionTypeNotNilAndNotEmpty,
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_OPERATION,
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_OPERATION,
    },
    {
      disabled,
      inputWrapperStyles,
      useMenuPortalTarget: true,
      label: ['titles:value', 'Value'],
      isRequired: isConditionTypeNotNilAndNotEmpty,
      isMulti: R.equals(operation, GC.FIELD_OPERATION_IN),
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      shouldCustomChange: G.isFalse(isTriggerConditionTypeNumberField),
      options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_VALUE,
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_VALUE,
      type: G.ifElse(isTriggerConditionTypeNumberField, 'number', 'reactSelect'),
    },
    {
      type: 'reactSelect',
      useMenuPortalTarget: true,
      options: repeatTypeOptions,
      fieldName: GC.FIELD_REPEAT_TYPE,
      label: ['titles:repeat-type', 'Repeat Type'],
      isRequired: repeatTypeIsRequired(trigger, repeatValue),
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      inputWrapperStyles: {
        ...inputWrapperStyles,
        display: G.ifElse(hasRepeatFields(trigger), 'flex', 'none'),
      },
    },
    {
      type: 'text',
      fieldName: GC.FIELD_REPEAT_VALUE,
      isRequired: repeatValueIsRequired(repeatType),
      label: ['titles:repeat-value', 'Repeat Value'],
      inputWrapperStyles: {
        ...inputWrapperStyles,
        mr: 225,
        display: G.ifElse(hasRepeatFields(trigger), 'flex', 'none'),
      },
    },
    {
      isMulti: true,
      isRequired: true,
      inputWrapperStyles,
      type: 'reactSelect',
      shouldCustomChange: true,
      useMenuPortalTarget: true,
      label: ['titles:message-types', 'Message Types'],
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES,
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES,
    },
    {
      isMulti: true,
      inputWrapperStyles,
      type: 'reactSelect',
      useMenuPortalTarget: true,
      label: ['titles:email-types', 'Email Types'],
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES,
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES,
      isRequired: R.and(
        G.isNotNilAndNotEmpty(trigger),
        R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_EMAIL, messageTypes),
      ),
      disabled: R.or(
        G.isNilOrEmpty(trigger),
        G.notContain(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_EMAIL, messageTypes),
      ),
    },
    {
      type: 'multiEmail',
      inputWrapperStyles,
      shouldOverrideEmails: true,
      label: ['titles:static-emails', 'Static Emails'],
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_STATIC_EMAILS,
      isRequired: R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES_STATIC, emailTypes),
      disabled: G.notContain(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES_STATIC, emailTypes),
    },
    {
      isMulti: true,
      type: 'reactSelect',
      useMenuPortalTarget: true,
      label: ['titles:references', 'References'],
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_REFERENCE_TYPES,
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_REFERENCE_TYPES,
      inputWrapperStyles: {
        ...inputWrapperStyles,
        display: ({ values }) => {
          const { trigger, objectType } = values;

          const loadObjectTypes = [
            GC.NOTIFICATION_OBJECT_TYPE_CLO,
            GC.NOTIFICATION_OBJECT_TYPE_TEL,
          ];

          const condition = R.or(
            R.includes(objectType, loadObjectTypes),
            R.equals(
              trigger,
              GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_TRAILER_ACTIVITY_TRAILER_ASSIGNED_TO_TEL,
            ),
          );

          if (condition) return 'flex';

          return 'none';
        },
      },
    },
  ];

  if (R.and(
    R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_EMAIL, messageTypes),
    G.isNotNilAndNotEmpty(mailTemplateGuid),
  )) {
    secondNotificationFieldset = R.append({
      inputWrapperStyles,
      type: 'reactSelect',
      useMenuPortalTarget: true,
      label: ['titles:template', 'Template'],
      closeMenuOnScroll: R.pathEq('form_wrapper', ['target', 'id']),
      options: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MAIL_TEMPLATE_GUID,
      fieldName: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MAIL_TEMPLATE_GUID,
    }, secondNotificationFieldset);
  }

  return secondNotificationFieldset;
};

export const getOptions = (options) => (
  R.compose(
    R.map((option) => ({ value: option.value, label: G.getEnumLocale(option.label) })),
    R.filter((filteredOption) => G.isNotNilAndNotEmpty(filteredOption)),
  )(options)
);

export const getEmailTypesOptions = (
  notificationOptions,
  triggerName,
) => (
  R.compose(
    R.map((item) => ({ value: item, label: G.getEnumLocale(item) })),
    R.pathOr([], ['0', GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES]),
    R.filter(({ trigger }) => R.equals(trigger, triggerName)),
  )(notificationOptions)
);

export const getConditionValuesOptions = (
  options,
  triggerName,
  conditionType,
) => {
  if (G.isNilOrEmpty(options)) return;

  const condition = R.and(
    R.equals(triggerName, GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER_STATUS_MESSAGE),
    G.notEquals(conditionType, GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_TYPE_WARNING_LEVEL),
  );

  if (condition) return options;

  return R.map(({ value, label }) => (
    { value, label: G.getEnumLocale(label) }
  ), options);
};

export const getDataTriggers = ({ setObjType, setCondition, notificationOptions }, value) =>
  R.forEach(
    ({ trigger, objectTypes, conditions }) => {
      if (R.equals(trigger, value)) {
        const typeObj = R.map(
          (typeName) => ({ label: typeName, value: typeName }),
          objectTypes,
        );

        const conditionType = R.map(
          (conditionName) => ({ label: conditionName, value: conditionName }),
          conditions,
        );

        setObjType(typeObj);

        setCondition(conditionType);

        if (G.isNilOrEmpty(conditionType)) setCondition(null);
      }
    },
    notificationOptions,
  );

export const notificationMessageTypesOptions = [
  {
    label: G.getWindowLocale('titles:internal', 'Internal'),
    value: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_INTERNAL,
  },
  {
    label: G.getWindowLocale('titles:email', 'Email'),
    value: GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_EMAIL,
  },
];

const defaultSchema = {
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_LEVEL]: G.yupStringRequired,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER]: G.yupStringRequired,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_OBJ_TYPE]: G.yupStringRequired,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES]: G.yupArrayRequired,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_NAME]: G.yupStringRequired
    .min(3, G.getShouldBeFromToLocaleTxt(3, 40))
    .max(40, G.getShouldBeFromToLocaleTxt(3, 40)),
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_REFERENCE_TYPES]: Yup.array()
    .nullable(true)
    .notRequired()
    .max(10, G.getShouldBePickOnlyLocaleTxt(10)),
};

export const getValidationSchema = (values, notificationOptions) => {
  const {
    trigger,
    operation,
    roleGuids,
    repeatType,
    emailTypes,
    repeatValue,
    messageTypes,
    dispatchingGroupGuids,
  } = values;

  let schema = defaultSchema;
  if (hasRepeatFields(trigger)) {
    schema = {
      ...schema,
      [GC.FIELD_REPEAT_TYPE]: G.ifElse(
        repeatTypeIsRequired(trigger, repeatValue),
        G.yupStringRequired,
        G.yupStringNotRequired,
      ),
      [GC.FIELD_REPEAT_VALUE]: G.ifElse(repeatValueIsRequired(repeatType), G.yupNumberRequired, G.yupNumberNotRequired)
        .min(1, G.getShouldBeFromToLocaleTxt(1, 999999999))
        .max(999999999, G.getShouldBeFromToLocaleTxt(1, 999999999)),
    };
  }

  if (R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_INTERNAL, messageTypes)) {
    schema = {
      ...schema,
      [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_ROLE]: G.ifElse(
        G.isNilOrEmpty(dispatchingGroupGuids),
        G.yupArrayRequired,
      ),
      [GC.FIELD_DISPATCHING_GROUP_GUIDS]: G.ifElse(
        G.isNilOrEmpty(roleGuids),
        G.yupArrayRequired,
      ),
    };
  }

  if (R.and(
    G.isNotNilAndNotEmpty(trigger),
    R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES_EMAIL, messageTypes),
  )) {
    if (R.includes(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES_STATIC, emailTypes)) {
      schema = R.assoc(
        GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_STATIC_EMAILS,
        G.yupArrayRequired,
        schema,
      );
    }

    schema = R.assoc(
      GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES,
      G.yupArrayRequired,
      schema,
    );
  }
  const conditions = R.compose(
    R.path(['0', 'conditions']),
    R.filter((item) => R.equals(
      G.getPropFromObject(GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER, item),
      trigger,
    )),
  )(notificationOptions);

  if (G.isNilOrEmpty(conditions)) {
    return schema;
  }

  let notificationValueFieldSchema = {
    [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_VALUE]: G.ifElse(
      R.equals(operation, GC.FIELD_OPERATION_IN),
      G.yupArrayRequired,
      G.yupStringRequired,
    ),
  };

  if (getIsTriggerConditionTypeNumberField(trigger)) {
    notificationValueFieldSchema = {
      [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_VALUE]: Yup.number()
        .nullable(true)
        .required(G.getRequiredLocaleTxt())
        .positive(G.getShouldBePositiveLocaleTxt()),
    };
  }

  return R.mergeRight(schema, {
    ...notificationValueFieldSchema,
    [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_TYPE]: G.yupStringRequired,
    [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_OPERATION]: G.yupStringRequired,
  });
};

export const defaultNotificationValues = {
  [GC.FIELD_REPEAT_TYPE]: null,
  [GC.FIELD_DISPATCHING_GROUP_GUIDS]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_NAME]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_ROLE]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_LEVEL]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_VALUE]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_TRIGGER]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_OBJ_TYPE]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_EMAIL_TYPES]: [],
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MESSAGE_TYPES]: [],
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_STATIC_EMAILS]: [],
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_REFERENCE_TYPES]: [],
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_TYPE]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_MAIL_TEMPLATE_GUID]: null,
  [GC.FIELD_CONFIGURATION_COMMUNICATION_NOTIFICATION_CONDITION_OPERATION]: null,
};
